export enum PlotlyColoursEnum {
  DARK_MODE_GRID_COLOUR = '#FFFFFF40',
  DARK_MODE_TICK_COLOUR = 'white',
  DARK_MODE_AXIS_COLOUR = 'white',
  LIGHT_MODE_GRID_COLOUR = '#00000040',
  LIGHT_MODE_TICK_COLOUR = 'black',
  LIGHT_MODE_AXIS_COLOUR = 'black',
}
